<h5 class="zint-card-title max-width-85">{{ label }}</h5>
@if(displayValue === undefined || displayValue === null) {
<div class="aira-nodata-icon-backdrop">
    <i class="fa-duotone fa-thin fa-input-numeric"></i>
    <p>No insights have been derived.</p>
</div>
}
@else {
<div class="d-flex justify-content-center align-items-center h-75" [ngClass]="{'blur-content': previewOnly}">
    <div class="zint-base-card d-inline-block px-4">
        <h4 class="text-grey-600 text-bold-600 long-text">{{ prepend || '' }} {{ displayValue | number: '1.0-0' }}</h4>

        <small class="d-inline-block text-grey-500 text-right">{{ append || ''}}</small>
    </div>
</div>
}
